import { atom } from "recoil";

const globalConfigAtom = atom({
    key: "globalConfig",
    default: null
})

export default globalConfigAtom;